<template>
  <div>
    <SectionHeader>
      <h1>Reset Your Password</h1>
    </SectionHeader>
    <SectionWrapper class="whiteframe shadowframe">
      <form-with-captcha
        ref="remindForm"
        @loading="setLoading"
        :request-data="user"
        @success="onSuccess"
        :after-captcha-verified="services.UserResource.sendPasswordReminder"
      >
        <FieldWrapper>
          <input
            type="email"
            v-model="user.email"
            name="email"
            tabindex="1"
            placeholder="E-mail"
            v-validate="validatorDefinitions.email"
            data-vv-scope="password-remind"
            autofocus
          />
          <span slot="errors" v-if="errors.has('email', 'password-remind')">{{
            errors.first("email", "password-remind")
          }}</span>
        </FieldWrapper>
        <DecoratedButton @click="onSubmit" class="wide" :loading="loading">
          CONTINUE
        </DecoratedButton>
      </form-with-captcha>
    </SectionWrapper>
  </div>
</template>

<script>
import FormWithCaptcha from "@/components/partials/FormWithCaptcha";

export default {
  name: "auth-password-reminder",
  components: { FormWithCaptcha },
  data: function() {
    return {
      user: {
        email: ""
      },
      loading: false
    };
  },
  methods: {
    setLoading(val) {
      this.loading = val;
    },
    onSuccess() {
      this.$emit("continue");
    },
    onSubmit() {
      this.$validator.validateAll("password-remind").then(valid => {
        if (valid) {
          this.$refs.remindForm.onSubmit();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
